export const ROUTES = {
  ROOT: '/',
  BOOK: '/book',
  EXERCISE: '/exercise',
  SETTINGS: '/settings',
  STUDENTS: '/students',
  TEACHERS: '/teachers',
  TUTORS: '/tutors',
  STUDY_SETS: '/study-sets',
  SCHOOLS: '/schools',
  CERF_TOOL: '/cefrTool'
}
